/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Of_Landing_CtaInputs */

const en_of_landing_cta = /** @type {(inputs: Of_Landing_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open your workspace`)
};

const id_of_landing_cta = /** @type {(inputs: Of_Landing_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masuk ke workspace`)
};

/**
* | output |
* | --- |
* | "Open your workspace" |
*
* @param {Of_Landing_CtaInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const of_landing_cta = /** @type {((inputs?: Of_Landing_CtaInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Of_Landing_CtaInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_of_landing_cta(inputs)
	return en_of_landing_cta(inputs)
});